import React, { Component, Fragment } from "react";
import {
  DeleteResponseModel,
  PlatformLinkResourcesResponseModel,
} from "../../../shared/models";
import { PlatformService } from "./services/platform.service";
import { HttpResponse } from "../../../core";
import {
  ShowSuccessMessage,
  HandleNotFoundResponse,
} from "../../../shared/helpers";
import { PlatformTabs } from "./PlatformTabs";
import { NavLink } from "react-router-dom";
import { ButtonType, NotFoundResponseArea } from "../../../shared/enums";

interface IState {
  result?: PlatformLinkResourcesResponseModel;
  deleteResult?: DeleteResponseModel;
  isDoubleleClick?: boolean;
}
export class DeletePlatform extends Component<any, IState> {
  private service: PlatformService;
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.service = new PlatformService();
    this.deleteRecord = this.deleteRecord.bind(this);
  }

  initialState: Partial<IState> = {
    result: {
      id: 0,
      title: "",
      extractor: {
        id: 0,
        type: "",
        schema_id: 0,
        extraction_scheduling_recipe_id: 0,
      },
      categories: [],
      connections: [],
    },
    deleteResult: { isdeleted: false },
    isDoubleleClick: false,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.service
      .getLinkedResourcesById(this.props.match.params.id)
      .then((res: HttpResponse<PlatformLinkResourcesResponseModel>) => {
        if (res && res.result) {
          this.setState({
            result: res.result,
          });
        }
      })
      .catch((ex) => {
        HandleNotFoundResponse(ex, NotFoundResponseArea.Platforms, this.props);
      });
  }

  deleteRecord() {
    if (!this.state.isDoubleleClick) {
      this.setState({ isDoubleleClick: true });
      this.service
        .deleteRecordById(this.props.match.params.id)
        .then((res: HttpResponse<DeleteResponseModel>) => {
          if (res && res.result) {
            this.setState(
              {
                deleteResult: res.result,
              },
              () => {
                if (this.state.deleteResult?.isdeleted) {
                  ShowSuccessMessage("Platform Successfully Deleted.");
                  this.props.history.push("/platform/list");
                }
              }
            );
          }
        });
    }
  }
  render() {
    return (
      <Fragment>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5>Delete Platform '{this.state.result?.title}'</h5>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card"> 
              <div className="card-body">
                <PlatformTabs
                  id={this.props.match.params.id}
                  url="/platform/delete/"
                />
                <div className="alert font-weight-bold  alert-light">
                  {" "}
                  <i className="fas fa-exclamation-circle text1"></i> Are you
                  sure you want to delete this Platform{" "}
                  <strong>"{this.state.result?.title}”</strong> ?
                </div>

                <p className="mt-4 text-danger">
                  <i className="fas fa-exclamation-triangle text1"></i> The
                  following related items may be deleted or orphaned:
                </p>
                <div className="row ">
                  <div className="col-4">
                    <div className="card card-primary shadow-sm">
                      <div className="card-header">
                        <h4>Platform</h4>
                      </div>
                      <div className="card-body">
                        <NavLink
                          className="badge badge-light text-link"
                          to={"/platform/detail/" + this.props.match.params.id}
                        >
                          {this.state.result?.title}
                        </NavLink>
                      </div>
                    </div>
                  </div>
                  {this.state.result?.categories &&
                    this.state.result?.categories.length > 0 && (
                      <div className="col-4">
                        <div className="card card-primary shadow-sm">
                          <div className="card-header">
                            <h4>Categories</h4>
                          </div>
                          <div className="card-body">
                            {this.state.result?.categories.map((category,index) => (
                             <span key={index}>
                             {category && <NavLink to={"/category/detail/" + category.value} className="badge badge-light m-1"><strong>{index + 1}:</strong> {category.text}</NavLink>}
                         </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  {this.state.result?.extractor !== null && (
                    <div className="col-4">
                      <div className="card card-primary shadow-sm">
                        <div className="card-header">
                          <h4>Schema Id</h4>
                        </div>
                        <div className="card-body">
                        <NavLink to={"/schema/detail/" + this.state.result?.extractor.schema_id} className="badge badge-light m-1">Extractor {this.state.result?.extractor.schema_id}</NavLink>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.result?.extractor !== null && (
                    <div className="col-4">
                      <div className="card card-primary shadow-sm">
                        <div className="card-header">
                          <h4>Extraction scheduling recipe</h4>
                        </div>
                        <div className="card-body">
                          <NavLink to={"/extraction-scheduling-recipe/detail/" + this.state.result?.extractor.extraction_scheduling_recipe_id} className="badge badge-light m-1"> ExtractionSchedulingRecipe # {this.state.result?.extractor.extraction_scheduling_recipe_id}</NavLink>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.result?.connections &&
                    this.state.result?.connections.length > 0 && (
                      <div className="col-4">
                        <div className="card card-primary shadow-sm">
                          <div className="card-header">
                            <h4>Connections</h4>
                          </div>
                          <div className="card-body">
                            {this.state.result?.connections.map(
                              (connection) => (
                                <NavLink
                                  className="badge badge-light m-1"
                                  to={"/connection/detail/" + connection.id}
                                >
                                  <div>{connection.name}</div>
                                </NavLink>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="mx-auto">
                <button
                  className="btn btn-lg btn-danger"
                  disabled={this.state.isDoubleleClick}
                  onClick={this.deleteRecord}
                >
                  {" "}
                  {ButtonType.Delete}
                </button>
                <NavLink
                  type="button"
                  className="btn btn-lg btn-default ml-3"
                  to="/platform/list"
                >
                  {ButtonType.Cancel}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
